import axios from 'axios'


/**
 * 
 * @status no delete
 * @class ModuleRoleService
 */
class ModuleRoleService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Alan Aguilar
  * @description Get the modules of a role bu userRoleId from A3cloud
  * @date 08-09-2020
  * @param {Number} roleId
  * @param {Object} token
  * @returns {Object}
  * @memberof ModuleRoleService
  */
  async getModulesByUserRoleId(roleId, token) {
    let response = await axios.get(`${this.apiUrl}/module-roles?roleId=${roleId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
 * @author Junaid Khan
 * @description Get the modules from A3 by assignRoles
 * @date 19-11-2023
 * @status no delete
 * @param {Object} token
 * @returns {Object}
 * @memberof ModuleRoleService
 */
  async getModulesByAssignRoles(token) {
    let response = await axios.get(`${this.apiUrl}/modules-by-assignRoles-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
* @author Junaid Khan
* @updatedBy Jorge Perales
* @description Get all the modules on left panel
* @date 18-01-2022
* @updatedDate 23-07-2026
* @status no delete
* @param {String} token
* @param {String} botConfigId id of the user's default bot config, used to apply the bot's module business rules
* @returns {Object}
* @memberof UserSignatureProfileService
*/

  async getModulesOnLeftPanel(token, botConfigId) {
    let response = await axios.get(
      `${this.apiUrl}/modules-left-panel-passthrough?botConfigId=${botConfigId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

}

export { ModuleRoleService as default }
